import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { defaultLocale, localeOptions } from '@/constants/config'
import en from '@/locales/en.json'
import ru from '@/locales/ru.json'
import uz from '@/locales/uz.json'

Vue.use(VueI18n)

const messages = { en, ru, uz }
const locale =
  localStorage.getItem('lang') &&
  localeOptions.filter((x) => x.id === localStorage.getItem('lang')).length > 0
    ? localStorage.getItem('lang')
    : defaultLocale
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages
})

export default i18n
